<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix class="lbl">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <div class="col-md-12">
    <h4>Upload Document</h4>
    <p>File should be .pdf, .jpeg, .png</p>
  </div>
</div>
<mat-dialog-content>
  <div class="row">
    <div class="col-md-12">
      <div
        class="dropzone"
        appDocumentUpload
        (fileDropped)="onFileDropped($event)"
      >
        <!--$event-->
        <input
          type="file"
          accept=".png,.jpeg,.pdf"
          #fileDropRef
          id="fileDropRef"
          multiple
          (change)="fileBrowseHandler($event)"
        />
        <!--$event.target.files-->
        <h3>Drag and drop file here</h3>
        <h3>or</h3>
        <label for="fileDropRef">Browse for File</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h5 style="margin-top: 0.5rem">Uploaded Files</h5>
    </div>
  </div>
  <div
    class="card box-shadow card_style"
    *ngFor="let file of files; let i = index"
  >
    <div class="row document_wrap">
      <div class="col-md-2">
        <span matSuffix class="lbl">
          <mat-icon>description</mat-icon>
        </span>
      </div>
      <div class="col-md-4">
        <h4 class="name">{{ file?.name }}</h4>
        <p class="size">{{ formatBytes(file?.size) }}</p>
        <mat-progress-bar mode="determinate" value="60"></mat-progress-bar>
      </div>
      <div class="col-md-2">
        <span matSuffix class="lbl">
          <mat-icon style="color: #42deb1">check_circle</mat-icon>
        </span>
      </div>
      <div class="col-md-2">
        <span matSuffix class="lbl" (click)="deleteFile(i)">
          <mat-icon style="color: #ec5b55">delete_outline</mat-icon>
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>
